import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings_buildingIdEnpiInputs = z.any()
export type TagsGetAdminBuildings_buildingIdEnpiInputs = z.infer<typeof tagsGetAdminBuildings_buildingIdEnpiInputs>

export const paramsGetAdminBuildings_buildingIdEnpiInputs = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetAdminBuildings_buildingIdEnpiInputs = z.infer<typeof paramsGetAdminBuildings_buildingIdEnpiInputs>

export const querystringGetAdminBuildings_buildingIdEnpiInputs = z.object({ "periodFrom": z.string().date(), "periodTo": z.string().date() })
export type QuerystringGetAdminBuildings_buildingIdEnpiInputs = z.infer<typeof querystringGetAdminBuildings_buildingIdEnpiInputs>

export const responseGetAdminBuildings_buildingIdEnpiInputs = z.object({ "payload": z.object({ "inputs": z.array(z.object({ "key": z.string(), "label": z.string(), "unit": z.string(), "value": z.union([z.number(), z.null()]), "source": z.union([z.literal("card"), z.literal("recorded"), z.literal("manual")]), "warnings": z.array(z.string()) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminBuildings_buildingIdEnpiInputs = z.infer<typeof responseGetAdminBuildings_buildingIdEnpiInputs>

interface IGetAdminBuildings_buildingIdEnpiInputs extends BaseMethodType {
  tags: TagsGetAdminBuildings_buildingIdEnpiInputs,
  params: ParamsGetAdminBuildings_buildingIdEnpiInputs,
  querystring: QuerystringGetAdminBuildings_buildingIdEnpiInputs,
  response: ResponseGetAdminBuildings_buildingIdEnpiInputs
}
export const URL = '/admin/buildings/:buildingId/enpi/inputs'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings_buildingIdEnpiInputs,
    params: paramsGetAdminBuildings_buildingIdEnpiInputs,
    querystring: querystringGetAdminBuildings_buildingIdEnpiInputs,
    response: responseGetAdminBuildings_buildingIdEnpiInputs
  }
}
export interface AdminBuildings_buildingIdEnpiInputs extends BaseRouteType {
  get: IGetAdminBuildings_buildingIdEnpiInputs
}